module.exports = __webpack_public_path__ + "img/vote-1.90154ca3.png";